document.addEventListener("DOMContentLoaded", function(){

  function checkCartWeight(){

    fetch('/cart.js')
    .then(response => response.json())
    .then(cart => {

      let weight = cart.total_weight;

      if(weight > 10000){

        document
        .getElementById("heavy-weight-popup")
        .classList.add("active");

      }

    });

  }


  checkCartWeight();


  document.addEventListener("click", function(e){

    if(
      e.target.closest(
      '.ajax-add-to-cart, .add-to-cart, [name="add"]'
      )
    ){
      setTimeout(checkCartWeight,1500);
    }


    if(
      e.target.classList.contains("heavy-popup-close") ||
      e.target.classList.contains("heavy-popup-btn")
    ){
      document
      .getElementById("heavy-weight-popup")
      .classList.remove("active");
    }

  });

});